export default __webpack_public_path__ + "static/electrical_motor_w.3c759ed5135386d9c94578b05f1c446f.svg";